import gql from "graphql-tag";

export const MY_TIME_GET_EXAMINERS = gql`
  query getMyTimeExaminers($contractCode: String!, $locale: String!) {
    getMyTimeExaminers(contractCode: $contractCode, locale: $locale)
  }
`;
